module.exports = __webpack_public_path__ + "img/goal-04.c76edef9.png";